import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PermissionEnum } from '@app/core/services/administrator/models/enum/permission.enum';
import { PaymentType } from '@app/core/services/transaction/model/enum/payment-type.enum';
import { Transaction } from '@app/core/services/transaction/model/transaction.model';

@Component({
  selector: 'ap-initial-transaction-details-recovered',
  templateUrl: './initial-transaction-details-recovered.component.html',
  styleUrl: './initial-transaction-details-recovered.component.css',
  standalone: false
})
export class InitialTransactionDetailsRecoveredComponent implements OnInit {

  @Input() transaction: Transaction;
  @Input() userView = false;

  Permissions = PermissionEnum;
  PaymentType = PaymentType;

  constructor(private router: Router) {}

  ngOnInit(): void {
  }

  navigateToTransactionDetails(id: number) {
    if (this.userView) {
      this.router.navigate(['/users', this.transaction.mobilityAccountId, 'all', 'transactions', id]);
    } else {
      this.router.navigate(['/transactions', id]);
    }
  }
}
